export default function currencyToNumber(valor: string): string {
  let novoValor;
  novoValor = valor.replace(/\./g, '');
  novoValor = novoValor.replace(/,/, '.');
  return novoValor;
}
